export enum ActionType {
  JOIN_PRESENTATION = "JOIN_PRESENTATION",
  MOVE_NEXT = "MOVE_NEXT",
  MOVE_PREV = "MOVE_PREV",
  HEARTBEAT = "HEARTBEAT",
  DETAILS_UPDATED = "DETAILS_UPDATED",
  UPDATE_SLIDE = "UPDATE_SLIDE",
  UPDATE_SLIDE_IMAGE = "UPDATE_SLIDE_IMAGE",
  PRELOAD_SLIDE_IMAGE = "PRELOAD_SLIDE_IMAGE",
  // Host controller only: backend pushes the live copresenter roster.
  CO_PRESENTERS_CHANGED = "CO_PRESENTERS_CHANGED",
  // Host controller only: toggle whether copresenters may move slides.
  SET_CONTROL_LOCK = "SET_CONTROL_LOCK",
  // Host-only preview status: backend can't read the deck yet (drive.file not
  // granted) vs. it can. Drives the controller's "Live previews" card.
  PREVIEW_PERMISSION_REQUIRED = "PREVIEW_PERMISSION_REQUIRED",
  PREVIEW_READY = "PREVIEW_READY",
  // Backend → host: the extension's own slide drawings are on their way
  // (loading: true), or that run failed (loading: false). COP-19.
  PREVIEW_LOADING = "PREVIEW_LOADING",
  // Host controller only: someone was turned away because the free plan's
  // copresenter seats are full. Carries their name so the host can see who's
  // waiting at the door and upgrade to let them in.
  JOIN_BLOCKED = "JOIN_BLOCKED",
  // Host controller → backend: pause or resume ONE copresenter's slide control
  // (Pro). Also arrives inbound at the paused copresenter, which is how their
  // clicker knows to switch to view-only.
  SET_PRESENTER_PAUSED = "SET_PRESENTER_PAUSED",
  // Clicker → backend: a thumbnail it was given failed to load (a 403 on an
  // expired Slides contentUrl). Only we can see this — the browser fetches the
  // image straight from googleusercontent — so without telling the server it
  // keeps handing out the same dead URL from its own cache. The reply is an
  // ordinary PRELOAD_SLIDE_IMAGE carrying the replacement.
  PREVIEW_IMAGE_FAILED = "PREVIEW_IMAGE_FAILED",
  // Host controller → backend: remove ONE copresenter from the room. Also
  // arrives inbound at the removed copresenter, just before the backend closes
  // their socket, so they see "you were removed" instead of silently
  // reconnecting. Not a ban — the same link lets them join again.
  REMOVE_PRESENTER = "REMOVE_PRESENTER",
  // Backend → clicker: the drawings of one slide's click-animation steps, step
  // 0 first, or an empty list when the slide no longer has any.
  SLIDE_STEP_IMAGES = "SLIDE_STEP_IMAGES",
  // Backend → clicker: which click step of the current slide the deck is on,
  // read off the slideshow by the extension.
  UPDATE_SLIDE_STEP = "UPDATE_SLIDE_STEP",
}
